export default __webpack_public_path__ + "static/media/80.71ca20e7.jpg";